import { useCallback, useEffect, useState } from 'react';
import { Mail, Users } from 'lucide-react';
import { Container } from 'reactstrap';
import { CallAPIPostPromise } from 'Common/commaon';
import { Toaster } from 'components/ui/sonner';
import { getDecodeId } from 'slices/userProfile/thunk';
import { Referral, ReferralsTable } from './ReferralsTable';
import { SendInviteForm } from './SendInviteForm';
import './invite-homeowners.css';

export default function InviteHomeOwners() {
  const [activeTab, setActiveTab] = useState<'list' | 'invite'>('list');
  const [referrals, setReferrals] = useState<Referral[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadReferrals = useCallback(() => {
    setLoading(true);
    setError('');

    CallAPIPostPromise('/agent/referrals-homeowners', { agentId: getDecodeId() })
      .then((response: any) => {
        setReferrals(
          Array.isArray(response.data) ? response.data : response.data?.data || []
        );
      })
      .catch(() => setError('Unable to load homeowner referrals.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadReferrals();
  }, [loadReferrals]);

  return (
    <div className="page-content tailwind-prefix">
      <Container fluid>
        <div className="invite-homeowners-page">
          <Toaster position="top-right" />
          <main>
            <div className="invite-homeowners-tabs">
              <nav className="invite-homeowners-tabs__nav" aria-label="Homeowner referrals">
                <button
                  type="button"
                  className={`invite-homeowners-tab${activeTab === 'list' ? ' is-active' : ''}`}
                  aria-pressed={activeTab === 'list'}
                  onClick={() => setActiveTab('list')}
                >
                  <Users aria-hidden="true" />
                  Referrals List
                </button>
                <button
                  type="button"
                  className={`invite-homeowners-tab${activeTab === 'invite' ? ' is-active' : ''}`}
                  aria-pressed={activeTab === 'invite'}
                  onClick={() => setActiveTab('invite')}
                >
                  <Mail aria-hidden="true" />
                  Send Invite
                </button>
              </nav>
            </div>

            <div className="invite-homeowners-content">
              {activeTab === 'list' ? (
                <section className="referrals-panel" aria-label="Homeowner referrals list">
                  {loading ? (
                    <div className="referrals-state" role="status" aria-live="polite">
                      <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                      Loading homeowner referrals…
                    </div>
                  ) : error ? (
                    <div className="referrals-state referrals-state--error" role="alert">
                      <span>{error}</span>
                      <button type="button" onClick={loadReferrals}>Try again</button>
                    </div>
                  ) : (
                    <ReferralsTable referrals={referrals} />
                  )}
                </section>
              ) : (
                <div className="invite-homeowners-form-wrap">
                  <SendInviteForm
                    onInviteSent={() => {
                      setActiveTab('list');
                      loadReferrals();
                    }}
                  />
                </div>
              )}
            </div>
          </main>
        </div>
      </Container>
    </div>
  );
}
